// extracted by css-extract-rspack-plugin
export default {"actionItem":"DefinitionDangerZone-module__actionItem__Yzyx8","divider":"DefinitionDangerZone-module__divider__AXTBk"};